var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_27485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_27485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.4L9.08315 16.325C8.89865 16.5084 8.6639 16.6 8.3789 16.6C8.0939 16.6 7.85924 16.5084 7.6749 16.325C7.49157 16.1417 7.3999 15.9084 7.3999 15.625C7.3999 15.3417 7.49157 15.1084 7.6749 14.925L10.5999 12L7.6749 9.1083C7.49157 8.9238 7.3999 8.68905 7.3999 8.40405C7.3999 8.11905 7.49157 7.88438 7.6749 7.70005C7.85824 7.51672 8.09157 7.42505 8.3749 7.42505C8.65824 7.42505 8.89157 7.51672 9.0749 7.70005L11.9999 10.625L14.8917 7.70005C15.0762 7.51672 15.3109 7.42505 15.5959 7.42505C15.8809 7.42505 16.1156 7.51672 16.2999 7.70005C16.4999 7.90005 16.5999 8.13755 16.5999 8.41255C16.5999 8.68755 16.4999 8.91672 16.2999 9.10005L13.3749 12L16.2999 14.9168C16.4832 15.1013 16.5749 15.336 16.5749 15.621C16.5749 15.906 16.4832 16.1407 16.2999 16.325C16.0999 16.525 15.8624 16.625 15.5874 16.625C15.3124 16.625 15.0832 16.525 14.8999 16.325L11.9999 13.4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseSmall);
export default __webpack_public_path__ + "static/media/icon_close_small.0cce6e06f13b8dfd507561a5134a6e63.svg";
export { ForwardRef as ReactComponent };